module.exports = __webpack_public_path__ + "static/redwoods-f10cf5592a6d08d611806a3b5785a1e5.png";